import { statusVerifyComponent } from './verify.component';

export const statusVerifyStateName = 'app.verify';

export const statusVerifyState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    url: '/status/:orderId/verify?invalidBirthday',
    name: statusVerifyStateName,
    params: {
      orderId: null,
      invalidBirthday: null,
    },
    component: statusVerifyComponent.name,
  });
};



// WEBPACK FOOTER //
// ./src/app/components/status/verify/verify.state.js